export const componentName = 'BizPrintBarcode';
